import React from "react";

import { servicesConfig } from "../../utils/servicesConfig";


const ProductsPage = () => {
  return (
    <section className="price-section calendary-section">
      <div className="price-container">
        <h2>Cennik</h2>
        <p className="price-description">
          Sprawdź nasze ceny – bez ukrytych kosztów.
        </p>

        <div className="price-grid">
       {Object.values(servicesConfig).map((item, index) => {
        return (
            <div key={item.key} className="price-card">
            <h3>{item.name}</h3>
            <p className="price">{item.price} zł / 20 ton</p>
            <p className="price-info">{item.description}</p>
            </div>
        );
        })}

        </div>
      </div>
    </section>
  );
};

export default ProductsPage;